import { Card, Row, Spin } from 'antd';
import SignUpsV2Layout from './components/SignUpsV2Layout';

const LoadingCard = () => {
  return (
    <Card>
      <Row type="flex" justify="center" align="middle">
        <Spin size="large" />
      </Row>
    </Card>
  );
};

const SignUpsV2Tab = ({
  signupsData,
  signupsLoading,
  signupsByDateData,
  chartLoading,
  onDateRangeChange,
  onAttrMethodChange,
  onAttrWindowChange,
  onPageChange,
  onPageSizeChange,
  currentPage,
  pageSize,
  dateRange,
  attrMethod,
  attrWindow,
  campaignOrder,
}) => {
  if (chartLoading) {
    return <LoadingCard />;
  }

  return (
    <SignUpsV2Layout
      signupsData={signupsData}
      signupsLoading={signupsLoading}
      signupsByDateData={signupsByDateData}
      chartLoading={chartLoading}
      onDateRangeChange={onDateRangeChange}
      onAttrMethodChange={onAttrMethodChange}
      onAttrWindowChange={onAttrWindowChange}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      currentPage={currentPage}
      pageSize={pageSize}
      dateRange={dateRange}
      attrMethod={attrMethod}
      attrWindow={attrWindow}
      campaignOrder={campaignOrder}
    />
  );
};

export default SignUpsV2Tab;
